import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { getTranslations, Translations } from './api';

interface TranslationState {
  value: Translations;
  isLoading: boolean;
  error: string | null;
}

export const initialState: TranslationState = {
  value: {},
  isLoading: false,
  error: null,
};

function startLoading(state: TranslationState) {
  state.isLoading = true;
}

export const fetchTranslations = createAsyncThunk('fetchTranslations', async () => {
  const response = await getTranslations();
  return response;
});

export const translationSlice = createSlice({
  name: 'translation',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchTranslations.pending, startLoading);
    builder.addCase(fetchTranslations.fulfilled, (state, { payload }) => {
      state.value = payload;
      state.isLoading = false;
      state.error = null;
    });
    builder.addCase(fetchTranslations.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message || 'Fetching translations failed';
    });
  },
});

export default translationSlice.reducer;
